import getDecryptedToken from "../api/getDecryptedToken";

export function isPrintTemplate2Enabled(): boolean {
  return getDecryptedToken("featurePrintTemplate2") === "true";
}

export function isDoctorTransferEnabled(): boolean {
  return getDecryptedToken("featureDoctorTransfer") === "true";
}
